export const MODALS_NAME = {
    CAMPAIGN_ADD: 'campaign-add',
    CAMPAIGN_UPDATE: 'campaign-update',
    PARTNER_ADD_POSTBACK: 'partner-add-postback',
    PARTNER_UPDATE_POSTBACK: 'partner-update-postback',
};
